/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { CardElement, injectStripe } from "react-stripe-elements";
import Switcher from "../UI/Switcher";
import Notification from "../Notification";
import Loading from '../../components/UI/Loading';
import { fetchAchSetupIntent } from '../../actions/Stripe';
import { buildAchApiBody } from '../../utils/helpers';
export class RomingInputNumber extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isValidationError: false,
    };
    this.hendlerChange = this.hendlerChange.bind(this);
  }

  hendlerChange(e) {
    const { value } = e.target;
    const isValidationError = !/^\d{6,9}$/.test(value);
    this.state.isValidationError !== isValidationError &&
      this.setState({ isValidationError });
    this.props.onChange(e);
  }

  render() {
    const { isValidationError } = this.state;
    return (
      <input
        {...this.props}
        style={isValidationError ? { border: "1px solid red" } : {}}
        onChange={this.hendlerChange}
      />
    );
  }
}

RomingInputNumber.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string.isRequired,
};
RomingInputNumber.defaultProps = {
  onChange: (e) =>
    console.warn(e, "RomingInputNumber shuld have a onChange eventHendler"),
};

// eslint-disable-next-line react/no-multi-comp
export class AccountInputNumber extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isValidationError: false,
    };
    this.hendlerChange = this.hendlerChange.bind(this);
  }

  hendlerChange(e) {
    const { value } = e.target;
    const isValidationError = !/^\d{1,12}$/.test(value);
    this.state.isValidationError !== isValidationError &&
      this.setState({ isValidationError });
    this.props.onChange(e);
  }

  render() {
    const { isValidationError } = this.state;
    return (
      <input
        {...this.props}
        style={isValidationError ? { border: "1px solid red" } : {}}
        onChange={this.hendlerChange}
      />
    );
  }
}

AccountInputNumber.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string.isRequired,
};
AccountInputNumber.defaultProps = {
  onChange: (e) =>
    console.warn(e, "AccountInputNumber shuld have a onChange eventHendler"),
};

// eslint-disable-next-line react/no-multi-comp
class AddPaymant extends Component {
  constructor(props) {
    super(props);
    const cardList = props.cardList || [];
    this.state = {
      loading: false,
      isadd: cardList.length > 1 ? false : true,
      isBank: false,
      routing_number: "",
      account_number: "",
      account_holder_name: props.fullName || "",
      holder_email: props.userEmail || "",
      account_holder_type: "individual",
      openCard:true,
      defValue1:"",
      defValue2:"",
      card: (cardList.find((item) => item.default_source) || {}).id,
    };
    this.notVerifid = {};
    this.notVerifidInputs = {};
    this.submit = this.submit.bind(this);
    this.hendlerOnChange = this.hendlerOnChange.bind(this);
    this.hendlerOnChangeInput = this.hendlerOnChangeInput.bind(this);
    this.hendlerStripeElementChange = this.hendlerStripeElementChange.bind(
      this
    );
    this.HandleChangeCheckBoxDetails = this.HandleChangeCheckBoxDetails.bind(
      this
    );
  }

  /*static getDerivedStateFromProps(nextProps, prevState) {
    if ((nextProps.cardList.find(item => item.default_source) || {}).id !== prevState.card) {
      return {
        loading: false,
        isBank: false,
        routing_number: '',
        account_number: '',
        account_holder_name: '',
        account_holder_type: 'individual',
        isadd: nextProps.cardList.length > 1 ? false : true,
        card: (nextProps.cardList.find(item => item.default_source) || {}).id,
      };
    }
    return null;
  }*/
  componentWillReceiveProps(nextProps) {
    const cardList = nextProps.cardList || [];
    if (
      (cardList.find((item) => item.default_source) || {}).id !==
      this.state.card
    ) {
      this.setState({
        loading: false,
        isBank: false,
        routing_number: "",
        account_number: "",
        account_holder_name: "",
        account_holder_type: "individual",
        isadd: cardList.length > 1 ? false : true,
        card: (cardList.find((item) => item.default_source) || {}).id,
      });
    }
  }

  hendlerOnChange(e) {
    const { name, type, value: valueTarget, checked } = e.target;
    const value = type === "checkbox" ? checked : valueTarget;

    this.setState({ isadd: false, [name]: value });
  }

  hendlerOnChangeInput(e) {
    const { name, value } = e.target;
    this.setState({ isadd: true, [name]: value });
  }

  hendlerStripeElementChange() {
    this.setState({ isadd: true });
  }

  HandleChangeCheckBoxDetails() {
    this.setState((prevState) => ({ isBank: !prevState.isBank, isadd: true }));
  }

  getAchRequestContext() {
    const { uid, rootInfo, fromBUprofile, isBU, admin } = this.props;

    if (fromBUprofile) {
      return { member_id: null };
    }

    if ((isBU || admin) && rootInfo?.member?.id) {
      return { member_id: String(rootInfo.member.id) };
    }

    const memberId = uid || rootInfo?.id;
    if (memberId != null) {
      return { member_id: String(memberId) };
    }

    return { member_id: null };
  }

  getAchSetupIntentBody() {
    return buildAchApiBody(this.getAchRequestContext(), {
      verification: "instant",
    });
  }

  getStripeInstance(publishableKey, accountId) {
    if (!window.Stripe) {
      throw new Error("Stripe.js has not loaded yet.");
    }
    return window.Stripe(publishableKey, accountId ? { stripeAccount: accountId } : {});
  }

  async addBankAccountViaFinancialConnections() {
    const { account_holder_name, holder_email } = this.state;

    if (!account_holder_name.trim() || !holder_email.trim()) {
      throw new Error("Account holder name and email are required.");
    }

    const setupIntent = await fetchAchSetupIntent(this.getAchSetupIntentBody());

    if (!setupIntent.publishable_key || !setupIntent.client_secret) {
      throw new Error("Unable to start bank account setup.");
    }

    const stripe = this.getStripeInstance(
      setupIntent.publishable_key,
      setupIntent.account_id
    );
    const billing_details = {
      name: account_holder_name.trim(),
      email: holder_email.trim(),
    };

    const collect = await stripe.collectBankAccountForSetup({
      clientSecret: setupIntent.client_secret,
      params: {
        payment_method_type: "us_bank_account",
        payment_method_data: { billing_details },
      },
      expand: ["payment_method"],
    });

    if (collect.error) {
      throw new Error(collect.error.message);
    }

    let setupIntentResult = collect.setupIntent;

    if (setupIntentResult.status === "requires_confirmation") {
      const confirm = await stripe.confirmUsBankAccountSetup(
        setupIntent.client_secret
      );
      if (confirm.error) {
        throw new Error(confirm.error.message);
      }
      setupIntentResult = confirm.setupIntent;
    }

    if (setupIntentResult.status === "succeeded") {
      if (this.props.onAchSuccess) {
        this.props.onAchSuccess();
      }
      await window.modal.alert("Success", "Bank account added successfully.");
      return;
    }

    if (setupIntentResult.status === "requires_action") {
      await window.modal.alert(
        "Verification required",
        "Micro-deposits were sent to your bank account. Please verify the amounts once they appear."
      );
      if (this.props.onAchSuccess) {
        this.props.onAchSuccess();
      }
      return;
    }

    throw new Error("Bank account setup did not complete.");
  }

  async submit() {
    try {
      this.setState({ loading: true });
      if (this.state.isadd) {
        if (this.state.isBank) {
          await this.addBankAccountViaFinancialConnections();
        } else {
          const { token } = await this.props.stripe.createToken({
            name: this.props.fullName,
          });
          if (token) {
            this.props.addPaymant(token.id);
          }
        }
      } else {
        this.props.changeDefaultCard(
          this.state.card,
          this.getAchRequestContext()
        );
      }
      if (this.state.isadd && this.state.isBank) {
        this.setState({
          loading: false,
          account_holder_name: this.props.fullName || "",
          holder_email: this.props.userEmail || "",
        });
      } else if (this.state.isadd) {
        this.setState({ loading: false });
        this.el && this.el.clear();
      } else {
        this.setState({ loading: false });
      }
    } catch (error) {
      console.error(error);
      this.setState({ loading: false });
      await window.modal.alert(
        "Error",
        error.response?.data?.message || error.message
      );
    }
  }

  verifi(id) {
    return async () => {
      if (
        parseFloat(this.notVerifidInputs[id + "1"].value) > 0 &&
        parseFloat(this.notVerifidInputs[id + "2"].value) > 0
      ) {
       if( this.props.verifiBankAccount(
        id,
       "0."+ this.notVerifidInputs[id + "1"].value,
       "0."+  this.notVerifidInputs[id + "2"].value
      )){
        this.setState({openCard:!this.state.openCard})
        this.setState({defValue1:"",defValue2:""})
      }
      }
      
    };
  }

  cancelSource = async (item) => {
    const { admin } = this.props;
    const userCardList = this.props.cardList || this.props.rootInfo?.stripePaymentMethods || [];
    const achContext = this.getAchRequestContext();
   
    if (await window.modal.cnfirm("Are you sure?", "to remove this card")) {
      this.props.removeCard(
        item.id,
        admin ? true : false,
        userCardList.length === 1,
        achContext,
        this.props.fromBUprofile
      );
    }
  };

  canRemovePaymentMethod(item) {
    return !item.default_source;
  }

  renderRemovePaymentControl(item) {
    const hasSubscriptions = this.props.subscriptions?.length > 0;
    const isBU = this.props.isBU;

    if (this.canRemovePaymentMethod(item)) {
      return (
        <img
          title="Cancel"
          onClick={() => {
            this.cancelSource(item);
          }}
          className="chargeButton w-29"
          src="/assets/img/error-cancel.svg"
          alt="Cancel"
        />
      );
    }

    if (
      isBU &&
      item.default_source &&
      hasSubscriptions &&
      !this.props.fromBUprofile
    ) {
      return (
        <span className="paymentInfoIcon">
          <Notification>
            The customer has an active subscription (membership). Cannot remove
            the payment method.
          </Notification>
        </span>
      );
    }

    return null;
  }

  render() {
    const { loading, isBank,defValue1 ,defValue2} = this.state;
    const userCardList = this.props.cardList || this.props.rootInfo?.stripePaymentMethods || [];
    const isBU =this.props.isBU;
    const showTextToAdmin = isBU && this.props.rootInfo !==undefined;
    console.log("log",this.props)
    return (
      <div className={`checkout rel ${loading ? "loading" : ""}`}>
        {this.props.stripeUserId === null ? (
          <h1>Add Payment method for {this.props.fullName}</h1>
        ) : (
          <h1>Change Payment method for {this.props.fullName}</h1>
        )}
        <div>
          ACH
          <Switcher
            name="isBank"
            onChange={this.HandleChangeCheckBoxDetails}
            value={this.state.isBank}
            checked={this.state.isBank}
          />
          credit card
        </div>
        {userCardList.length <= 0 ? null : (
          <table>
            <tbody>
              {userCardList.length > 1 ? (
                <React.Fragment>
                  {userCardList.map((item) => (
                    <React.Fragment key={item.id}>
                      <tr key={item.id + "real"}>
                        <td style={{ paddingTop: "10px" }}>
                          <input
                            type="radio"
                            id={item.id}
                            name="card"
                            value={item.id}
                            checked={item.id === this.state.card}
                            onChange={this.hendlerOnChange}
                          />
                        </td>
                        <td>
                          <label
                            htmlFor={item.id}
                          >{`**** **** **** ${item.last4}`}</label>
                        </td>
                        <td>
                          <label htmlFor={item.id}  style={{position: "relative",top: "-6px"}}>
                            <img
                              src={
                                item.object === "card"
                                  ? "/assets/img/card.png"
                                  : "/assets/img/ach.png"
                              }
                              alt="card"
                            />
                           
                            {this.renderRemovePaymentControl(item)}
                            
                            {item.object === "bank_account" && (
                              <span> <br />
                              <span
                                className={
                                  item.status === "verified"
                                    ? "verified"
                                    : "notverified"
                                }
                                style={{marginLeft:"5px"}}
                                onClick={() => {
                                  this.setState({openCard:!this.state.openCard})
                                  this.setState({defValue1:"",defValue2:""})
                                  this.notVerifid[item.id].classList.toggle(
                                    "activ"
                                  );
                                }}
                              >
                               
                                {item.status === "verified"
                                  ? "verified"
                                  : "not verified"}
                              </span>
                              </span>
                            )}
                          </label>
                        </td>
                      </tr>
                      {item.object === "bank_account" &&
                        item.status !== "verified" ? (
                        <tr
                          className="verification-form"
                          ref={(ref) => (this.notVerifid[item.id] = ref)}
                        >
                          <td colSpan="3">
                            <div className="vrify-group">
                              <h3>
                              We sent two small deposits (in cents) to this bank account. Can take 1-2 business days till you see them on your bank account. To verify this account, please confirm the amounts of these deposits.
                              </h3>
                              <div className="verify_sub_group">
                                <div className="verify-col">
                                <label style={{display:"block"}}><b>First trans</b></label>
                                <span style={{fontSize:" 20px",verticalAlign: "middle"}}>0.</span> 
                                  <input
                                    ref={(ref) =>
                                    (this.notVerifidInputs[
                                      item.id + "1"
                                    ] = ref)
                                    }
                                    type="number"
                                    style={{width: "80% !important"}}
                                    onWheel={(e) => e.target.blur()}
                                    placeholder=""
                                  />
                                </div>
                                <div className="verify-col">
                                <label style={{display:"block"}}><b>Second trans</b></label>
                                <span style={{fontSize:" 20px",verticalAlign: "middle"}}>0.</span> 
                                  <input
                                    ref={(ref) =>
                                    (this.notVerifidInputs[
                                      item.id + "2"
                                    ] = ref)
                                    }
                                    type="number"
                                    style={{width: "80% !important"}}
                                    onWheel={(e) => e.target.blur()}
                                    placeholder=""
                                  />
                                </div>
                                <div className="verify-col" style={{marginTop:"19px"}}>
                                  <div className="pretty-button">
                                    <button
                                      className="green-button h-30"
                                      disabled={this.props.verificationLoading}
                                      onClick={this.verifi(item.id)}
                                    >
                                      Verify
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="tr-min" />
                          </td>
                        </tr>
                      ) : (
                        <tr></tr>
                      )}
                    </React.Fragment>
                  ))}
                </React.Fragment>
              ) : (
                userCardList.map((item) => (
                  <React.Fragment key={item.id}>
                    <tr>
                      <td >
                        <label
                          htmlFor={item.id}
                          
                        >{`**** **** **** ${item.last4}`}</label>
                      </td>
                      <td >
                        <label htmlFor={item.id}  style={{position: "relative",top: "-6px"}}>
                          <img
                            src={
                              item.object === "card"
                                ? "/assets/img/card.png"
                                : "/assets/img/ach.png"
                            }
                            alt="card"
                          />
                          {this.renderRemovePaymentControl(item)}
                            
                          {item.object === "bank_account" && (
                            <span>
                               <br />
                           
                            <span
                              className={
                                item.status === "verified"
                                  ? "verified"
                                  : "notverified"
                              }
                              onClick={() => {
                                this.notVerifid[item.id].classList.toggle(
                                  "activ"
                                );
                              }}
                            >
                             
                              {item.status === "verified"
                                ? "verified"
                                : "not verified"}
                            </span>
                            </span>
                          )}
                        </label>
                      </td>
                    </tr>
                    {item.object === "bank_account" &&
                      item.status !== "verified" ? (
                      <tr
                        className="verification-form"
                        ref={(ref) => (this.notVerifid[item.id] = ref)}
                      >
                        <td colSpan="3">
                          <div className="vrify-group">
                            <h3>
                              We sent two small deposits to this bank account.To
                              verify this account, please confirm the amounts of
                              these deposits
                            </h3>
                            <div className="verify_sub_group">
                              <div className="verify-col">
                              <label style={{display:"block"}}><b>First trans</b></label>
                              <span style={{fontSize:" 20px",verticalAlign: "middle"}}>0.</span> 
                               <input
                                  ref={(ref) =>
                                    (this.notVerifidInputs[item.id + "1"] = ref)
                                  }
                                  type="number"
                                  style={{width: "80% !important"}}
                                  onWheel={(e) => e.target.blur()}
                                  placeholder=""
                                />
                              </div>
                              <div className="verify-col">
                              <label style={{display:"block"}}><b>Second trans</b></label>
                               <span style={{fontSize:" 20px",verticalAlign: "middle"}}>0.</span> 
                               <input
                                  style={{width: "80% !important"}}
                                  ref={(ref) =>
                                    (this.notVerifidInputs[item.id + "2"] = ref)
                                  }
                                  type="number"
                                 
                                  onWheel={(e) => e.target.blur()}
                                  placeholder=""
                                />
                               
                              </div>
                              <div className="verify-col" style={{marginTop:"19px"}}>
                                <button
                                  disabled={this.props.verificationLoading}
                                  onClick={this.verifi(item.id)}
                                >
                                  Verify
                                </button>
                              </div>
                            </div>
                          </div>
                          <div className="tr-min" />
                        </td>
                      </tr>
                    ) : (
                      <tr></tr>
                    )}
                  </React.Fragment>
                ))
              )}
            </tbody>
          </table>
        )}
        {isBank ? (
          showTextToAdmin ? (
            <p>For banking security your customers have to login and add ACH info on their end.</p>
          ) : (
            <div className="bankAccountForm">
              <input
                onChange={this.hendlerOnChangeInput}
                type="text"
                name="account_holder_name"
                value={this.state.account_holder_name}
                placeholder="Account holder name"
              />
              <input
                onChange={this.hendlerOnChangeInput}
                type="email"
                name="holder_email"
                value={this.state.holder_email}
                placeholder="Email"
              />
              <p>
                Connect your bank securely through Stripe. You will be prompted to
                log in to your bank for instant verification.
              </p>
            </div>
          )
        ) : (this.state.openCard &&
          <div>
            <h3>Card Info</h3>
            <CardElement
              onReady={(el) => {
                this.el = el;
              }}
              onChange={this.hendlerStripeElementChange}
              style={{ base: { fontSize: "16px" } }}
            />
          </div>
        )}
         <div className="sign-up-btn-new" style={{margin:"auto"}}>
              <div className="pretty-button ">
              {!(showTextToAdmin && isBank && this.state.isadd) && (
              <button className="green-button" type="button" onClick={this.submit}>
                {this.state.isadd
                  ? isBank
                    ? "Connect bank account"
                    : "Add Card"
                  : "Change"}
              </button>
              )}
              </div>
          </div>
        
        {this.state.loading?<Loading/>:null}
      </div>
    );
  }
}

AddPaymant.propTypes = {
  stripe: PropTypes.objectOf(PropTypes.any),
  fullName: PropTypes.string.isRequired,
  userEmail: PropTypes.string,
  stripeUserId: PropTypes.string,
  cardList: PropTypes.arrayOf(PropTypes.any),
  addPaymant: PropTypes.func.isRequired,
  changeDefaultCard: PropTypes.func.isRequired,
  verifiBankAccount: PropTypes.func.isRequired,
  verificationLoading: PropTypes.bool.isRequired,
  onAchSuccess: PropTypes.func,
  uid: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  user_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  businessId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  admin: PropTypes.bool,
  fromBUprofile: PropTypes.bool,
  isBU: PropTypes.bool,
  rootInfo: PropTypes.objectOf(PropTypes.any),
};
AddPaymant.defaultProps = {
  stripe: null,
  userEmail: "",
  stripeUserId: null,
  cardList: [],
  onAchSuccess: null,
  uid: null,
  user_id: null,
  businessId: null,
  admin: false,
  fromBUprofile: false,
  isBU: false,
  rootInfo: undefined,
};
export default injectStripe(AddPaymant);
